export class AbConsoleLogger {
  /**
   * Get the ISO date string
   */
  static getISODate() {
    return new Date().toISOString();
  }

  /**
   * A temporary creation until ES2017 version of String.padStart exists.
   * Note that this version only works if padding is a single character.
   * @param str - string to pad
   * @param length - how long to pad it to
   * @param padding - what to pad it with.  Default value is "space"
   */
  static padStart(str, length, padding) {
    if (str.length >= length + 1) {
      return str;
    }
    return Array(length + 1 - str.length).join(padding == null ? " " : padding) + str;
  }
  static shortId(id) {
    // word after the last slash or backslash, padded
    const word = /(?!.*[\/\\])\w+/.exec(id);
    return AbConsoleLogger.padStart(word != null ? word[0] : id, 20);
  }
  /**
   * Appends a debug log.
   *
   * @param logger The source logger.
   * @param rest The data to log.
   */
  debug(logger, ...rest) {
    console.debug(`DEBUG ${AbConsoleLogger.getISODate()} [${AbConsoleLogger.shortId(logger.id)}]`, ...rest);
  }

  /**
   * Appends an info log.  Does NOT put out the line number.
   *
   * @param logger The source logger.
   * @param rest The data to log.
   */
  info(logger, ...rest) {
    console.info(`INFO ${AbConsoleLogger.getISODate()} [${AbConsoleLogger.shortId(logger.id)}]`, ...rest);
  }

  /**
   * Appends a warning log.
   *
   * @param logger The source logger.
   * @param rest The data to log.
   */
  warn(logger, ...rest) {
    console.warn(`WARN ${AbConsoleLogger.getISODate()} [${AbConsoleLogger.shortId(logger.id)}]`, ...rest);
  }

  /**
   * Appends an error log.
   *
   * @param logger The source logger.
   * @param rest The data to log.
   */
  error(logger, ...rest) {
    //console.error(`ERROR ${AbConsoleLogger.getISODate()} [${AbConsoleLogger.shortId(logger.id)}]`, ...rest, AbConsoleLogger.getLineNumber(new Error()));
    // ABSDK-1781: Instances of Error log much better than their toString() flavors, so separate the messages.
    // eslint-disable-next-line abinitio/no-instanceof
    if (rest.some(x => x instanceof Error)) {
      console.error(`ERROR ${AbConsoleLogger.getISODate()} [${AbConsoleLogger.shortId(logger.id)}] Stack follows:`);
      console.error(...rest);
    } else {
      console.error(`ERROR ${AbConsoleLogger.getISODate()} [${AbConsoleLogger.shortId(logger.id)}]`, ...rest);
    }
  }
}
//# sourceMappingURL=AbConsoleLogger.js.map
